export default __webpack_public_path__ + "static/media/mar-gameboard-03.7f57b534.jpg";